import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-2 border p-4" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<p> What now? </p><p> Merchant steps: </p><ul class=\"list-group-numbered px-0\"><li>Signup and login</li><li>Add your product</li><li>Compete offers</li></ul><p> Consumer steps: </p><ul class=\"list-group-numbered px-0\"><li>Signup and login</li><li>Search and filter</li><li>Compare offers</li></ul>", 5)
const _hoisted_8 = { class: "col-10 p-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h2", null, "Your stock", -1)
const _hoisted_10 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, [
        _createVNode(_component_RouterLink, { to: { name: 'merchandises-create' } }, {
          default: _withCtx(() => [
            _createTextVNode("Upload CSV file")
          ]),
          _: 1
        })
      ]),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.limitArray(5), (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id,
          class: "border p-2 mb-4"
        }, [
          _createElementVNode("h3", null, _toDisplayString(item.name), 1),
          _createElementVNode("div", null, _toDisplayString(item.barcode), 1),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("small", _hoisted_10, [
                _createVNode(_component_RouterLink, {
                  to: { name: 'merchandises-details', params: { id: item.id } }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Details")
                  ]),
                  _: 2
                }, 1032, ["to"]),
                _createTextVNode(" | "),
                _createVNode(_component_RouterLink, {
                  to: { name: 'merchandises-edit', params: { id: item.id } }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Edit")
                  ]),
                  _: 2
                }, 1032, ["to"]),
                _createTextVNode(" | "),
                _createVNode(_component_RouterLink, {
                  to: { name: 'merchandises-delete', params: { id: item.id } }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Delete")
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}